export default __webpack_public_path__ + "static/prob2-ae0e4dc21b44817954f398c754cb94da.png";